import { generateAiWords } from '../analysis/generateAiWords';

// actionName と function のマッピング
export const analysisCallMap = {
  generateAiWords: generateAiWords,
};
